import { createReducer, on } from '@ngrx/store';
import * as GlobalActions from './global.actions';

export interface GlobalState {
   countryCode: string;
}

export const initialState: GlobalState = {
   countryCode: 'US',
};

export const globalReducer = createReducer(
   initialState,

   on(GlobalActions.setCountryCode, (state, { countryCode }) => ({
      ...state,
      countryCode,
   }))
);
